class CoffeeChapterGuide extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const tablist = this.querySelector('.coffee-chapter-guide__tabs');
    const tabs = [...tablist.querySelectorAll('button')];
    const panels = [...this.querySelectorAll('.coffee-chapter-guide__panel')];
    const activate = (index, focus = false) => {
      tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panels[position].hidden = !selected;
      });
      if (focus) tabs[index].focus();
    };
    tablist.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].tabIndex = 0;
    });
    tablist.addEventListener('click', (event) => {
      const index = tabs.indexOf(event.target.closest('button'));
      if (index !== -1) activate(index);
    }, { signal: this.controller.signal });
    tablist.addEventListener('keydown', (event) => {
      const index = tabs.indexOf(event.target.closest('button'));
      if (index === -1) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) {
        event.preventDefault();
        activate(next, true);
      }
    }, { signal: this.controller.signal });
    this.closest('.shopify-section')?.querySelectorAll('.kaizen-roast-rest-link').forEach((link) => {
      if (link.hash !== `#${panels[0].id}`) return;
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        activate(0);
        tabs[0].focus({ preventScroll: true });
        this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, { signal: this.controller.signal });
    });
    activate(0);
    tablist.hidden = false;
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
}
if (!customElements.get('coffee-chapter-guide')) customElements.define('coffee-chapter-guide', CoffeeChapterGuide);
